import React, { Fragment } from 'react'

import Wizard from '@modules/form-wizard'
import toastr from '@modules/toastr'
import SERVICE_PROPS from '@helpers/extract-service-props'
// import { BUSINESS_FIELDS } from '@modules/form-wizard/utils'
// import InputField from '@shared/form-fields/input'
import Loader from '@shared/loader'
// import DateTimeFieldV2 from '@shared/form-fields/datetime'
import moment from 'moment'
import islands from '@constants/islands'
import { UPSKILL_BAHAMAS_COURSES, UPSKILL_BAHAMAS_COURSES_SUMMARY } from './misc_modules/upskill-bahamas-courses'
import Swal from 'sweetalert2'

export default class UpskillBahamas extends React.Component {
  state = { record: null, loading: false, date: new Date() }

  resource = '/moe/up_skill_bahamas'
  form_key = 'up_skill_bahama'

  free = true
  skip_location = true
  hide_buttons = {
    approve: true,
    status: true,
    deny: true,
  }

  custom_actions = [
  ]

  // defaults = {
  //   "client_type": "individual",
  // }

  foremost = null

  validate = async form => {
    const age = moment().diff(moment(form.minor_date_of_birth), 'years')
    if (age < 16) {
      toastr.error('The minor must be at least 16 years old to apply for this program.')
      return false
    }
    if (age > 18) {
      toastr.error('This person must apply for themselves.')
      return false
    }
    if (form.bahamian_citizen === false) {
      toastr.error('This program is only available to Bahamian citizens.')
      return false
    }
    if (form.minor_nib_number && form.minor_nib_number.length !== 8) {
      toastr.error('NIB number must be 8 digits.')
      return false
    }

    let training_reason = form.training_reason
    if(training_reason == 'other') training_reason = form.other_training_reason;

    let sector_of_employment = form.sector_of_employment
    if(sector_of_employment == 'other') sector_of_employment = form.other_sector_of_employment;

    const courseSummaryHtml = [form.training_course, form.training_course_2]
      .filter(Boolean)
      .map(this.trainingCourseSummary)
      .filter(Boolean)
      .map(course => `
        <div style="text-align:left; border:1px solid #ddd; border-radius:6px; padding:10px; margin-top:10px;">
          <p style="margin:0 0 4px;"><strong>${course.title}</strong> (${course.provider})</p>
          <p style="margin:0 0 4px;">${course.description}</p>
          <p style="margin:0;"><strong>Length:</strong> ${course.length}</p>
          <p style="margin:0;"><strong>Requirement:</strong> ${course.requirement}</p>
          <p style="margin:0;"><strong>You Receive:</strong> ${course.receives}</p>
        </div>
      `)
      .join('')

    const applicantFields = form.i_am_applicant ? `
      <label style="display:flex; align-items:flex-start; gap:8px; margin-top:14px;">
        <input type="checkbox" id="confirm-info-commit" style="margin-top:3px;">
        <span>I have checked the course duration and time commitment, and I am willing and able to complete it.</span>
      </label>
      <label style="display:flex; align-items:flex-start; gap:8px; margin-top:8px;">
        <input type="checkbox" id="confirm-time-commit" style="margin-top:3px;">
        <span>I commit to starting my selected course within two (2) weeks of being accepted into the programme and having access to the course.</span>
      </label>
    ` : `
      <label style="display:flex; align-items:flex-start; gap:8px; margin-top:14px;">
        <input type="checkbox" id="confirm-info-commit" style="margin-top:3px;">
        <span>The minor is aware of the course duration and time commitment, and is willing and able to complete it.</span>
      </label>
      <label style="display:flex; align-items:flex-start; gap:8px; margin-top:8px;">
        <input type="checkbox" id="confirm-time-commit" style="margin-top:3px;">
        <span>The minor commits to starting their course within two (2) weeks of being accepted into the programme and having access to the course.</span>
      </label>
    `

    const { isConfirmed } = await Swal.fire({
      title: 'Confirm Submission',
      html: `
        <div style="text-align:left;">
          ${courseSummaryHtml}
          ${applicantFields}
        </div>
      `,
      icon: 'warning',
      width: '700px',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton()
        const checkboxes = [
          document.getElementById('confirm-info-commit'),
          document.getElementById('confirm-time-commit'),
        ]
        const updateConfirmButton = () => {
          confirmButton.disabled = !checkboxes.every(checkbox => checkbox.checked)
        }
        updateConfirmButton()
        checkboxes.forEach(checkbox => checkbox.addEventListener('change', updateConfirmButton))
      },
    })

    if (!isConfirmed) return false

    return {
      training_reason: training_reason,
      sector_of_employment: sector_of_employment,
      accept_start_date_commitment: true,
      accept_completion_commitment: true,
    }
  }

  trainingCourse = category => {
    return UPSKILL_BAHAMAS_COURSES[category] || []
  }

  trainingCourseSummary = course => {
    const foundCourse = UPSKILL_BAHAMAS_COURSES_SUMMARY.find(c => c.value === course)

    return foundCourse || null
  }


  fields = form => [
    {
      name: 'i_am_applicant',
      label: 'Who are you filling out this form for?',
      options: [
        { label: 'I am applying for myself', value: true },
        { label: 'I am applying on behalf of a minor (as their legal guardian)', value: false },
      ],
      type: 'select',
      callback: value => {
        if (value === true) {
          return { bahamian_citizen: null, minor_date_of_birth: null, minor_gender: null, minor_nib_number: null, first_name: null,
                   last_name: null, other_training_reason: null, other_sector_of_employment: null }
        }
      }
    },

    '::Section 1: Basic Details',
      {
      heading: `
        <span class='uppercase-x'>
          Since you are applying on behalf of a minor, please complete all questions 
          in this form as if you were them.
          That is, please answer questions on their behalf
        </span>
      `,
      view: false,
      hide: form.i_am_applicant,
    },
    {
      name: 'first_name',
      label: 'Minor\'s First Name',
      hint: 'Must match NIB card exactly.',
      hide: form.i_am_applicant,
    },
    {
      name: 'last_name',
      label: 'Minor\'s Last Name',
      hide: form.i_am_applicant,
    },
    {
      name: 'phone_number',
      label: form.i_am_applicant ? 'Phone Number' : 'Minor\'s Phone Number',
      type: 'phone',
      use_profile: 'additional_phone_number',
      // long: true,
    },

    {
      name: 'email',
      label: form.i_am_applicant ? 'Email Address' : 'Minor\'s Email Address',
      type: 'email',
      use_profile: 'email',
    },
    {
      name: 'contact_preference',
      label: form.i_am_applicant ? 'How do you prefer to be contacted?' : 'How does the minor prefer to be contacted?',
      type: 'select',
      options: [
        { label: 'Email', value: 'email' },
        { label: 'WhatsApp', value: 'whatsapp' },
        { label: 'No preference', value: 'n/a' },
      ],
    },

    '::SPACER',
    '::Section 2: Training Preference',
    {
      name: 'training_reason',
      label: form.i_am_applicant ? 'What is your primary reason for wanting to undertake a training course?' : "What is the minor's primary reason for wanting to undertake a training course?",
      type: 'select',
      options: [
        { label: 'Learn new skills that are useful for life', value: 'new skills' },
        { label: 'Improve productivity at current job', value: 'improve productivity' },
        { label: 'Switch careers', value: 'reskill' },
        { label: 'Find employment', value: 'find employment' },
        { label: 'Start a business', value: 'start business' },
        { label: 'Other', value: 'other' },
      ],
    },
    {
        name: 'other_training_reason',
        label: form.i_am_applicant ? 'Please state the reason for wanting to undertake a training course' : 'Please state the minor\'s reason for wanting to undertake a training course',
        hide: form.training_reason !='other'
    },
    {
      name: 'training_course_category',
      type: 'select',
      label: form.i_am_applicant ? 'Please select ONE training course category that you would like to undertake' : "Please select ONE training course category that the minor would like to undertake",
      options: [
        { label: 'New', value: 'new' },
        { label: 'Tech', value: 'tech' },
        { label: 'Business', value: 'business' },
        { label: 'Entrepreneurship', value: 'entrepreneurship' },
        { label: 'Health & Wellness', value: 'health wellness' },
        { label: 'Hospitality', value: 'hospitality' },
        { label: 'Language/Communication', value: 'language communication' },
        { label: 'Teaching', value: 'teaching' },
        { label: 'Skilled Trades', value: 'skilled trades' },
      ]
    },
    {
      name: 'training_course',
      type: 'select',
      label: form.i_am_applicant ? 'Please select ONE training course that you would like to undertake' : "Please select ONE training course that the minor would like to undertake",
      options: this.trainingCourse(form.training_course_category),
      hint: `<span>Note that full course descriptions can be found at 
        <a href="https://www.upskillbahamas.com/courses" target="_blank">www.upskillbahamas.com/courses</a></span>`,
    },
    {
      name: 'training_course_category_2',
      type: 'select',
      label: form.i_am_applicant ? 'In case the course selected above is not available, please select a second training course category that you would like to undertake' : "In case the course selected above is not available, please select a second training course category that the minor would like to undertake",
      options: [
        { label: 'New', value: 'new' },
        { label: 'Tech', value: 'tech' },
        { label: 'Business', value: 'business' },
        { label: 'Entrepreneurship', value: 'entrepreneurship' },
        { label: 'Health & Wellness', value: 'health wellness' },
        { label: 'Hospitality', value: 'hospitality' },
        { label: 'Language/Communication', value: 'language communication' },
        { label: 'Teaching', value: 'teaching' },
        { label: 'Skilled Trades', value: 'skilled trades' },
      ]
    },
    {
      name: 'training_course_2',
      type: 'select',
      label: 'In case the course selected above is at capacity, please select a second course',
      options: this.trainingCourse(form.training_course_category_2),
      hint: `<span>Note that full course descriptions can be found at 
        <a href="https://www.upskillbahamas.com/courses" target="_blank">www.upskillbahamas.com/courses</a></span>`,
    },

    '::SPACER',
    '::Section 3: Demographic Data',
    // Disable form if not Bahamian citizen
    {
      name: 'bahamian_citizen',
      type: 'select:bool',
      label: 'Is the minor a Bahamian citizen?',
      hide: form.i_am_applicant,
      callback: value => {
        if (value === false) {
          toastr.error('This program is only available to Bahamian citizens.')
        }
      }
    },
    {
      name: 'place_of_residence',
      label: form.i_am_applicant ? 'What is your primary place of residence?' : 'What is the minor\'s primary place of residence?',
      type: 'select',
      options: islands
    },
    {
      name: 'minor_date_of_birth',
      type: 'date',
      showYearDropdown: true,
      label: form.i_am_applicant ? 'What is your date of birth? (MM/DD/YYYY)' : 'What is the minor\'s date of birth? (MM/DD/YYYY)',
      hint: 'Please enter in the format MM/DD/YYYY',
      hide: form.i_am_applicant,
      view: form.i_am_applicant ? null : {
        value: value => {
          if (!value) return 'N/A'
          return moment(value).format('MM/DD/YYYY')
        }
      },
      callback: value => {
        const age = moment().diff(moment(value), 'years')
        if (age < 16) {
          toastr.error('The minor must be at least 16 years old to apply for this program.')
        }
        if (age > 18) {
          toastr.error('This person must apply for themselves.')
        }
      }
    },
    {
      name: 'minor_gender',
      type: 'select',
      label: form.i_am_applicant ? 'What is your gender?' : 'What is the minor\'s gender?',
      options: [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' },
        { label: 'Prefer not to say', value: 'n/a' },
      ],
      hide: form.i_am_applicant,
    },
    {
      name: 'disability_status',
      type: 'select:bool',
      label: form.i_am_applicant ? 'Do you have a disability?' : 'Does the minor have a disability?',
      hint: 'Note: This information is collected for statistical purposes only and will not affect your eligibility.',
    },
    {
      name: 'minor_nib_number',
      type: 'number',
      label: 'Minor\'s National Insurance (NIB) Number',
      hide: form.i_am_applicant,
      onBlur: value => {
        if (value && value.length !== 8) {
          toastr.error('NIB number must be 8 digits.')
          return { minor_nib_number: form.minor_nib_number.slice(0, 8) }
        }
      }
    },
    {
      name: 'employment_status',
      type: 'select',
      label: form.i_am_applicant ? 'What is your current employment status?' : 'What is the minor\'s current employment status?',
      options: [
        { label: 'Employed Full-Time', value: 'employed full time' },
        { label: 'Employed Part-Time', value: 'employed part time' },
        { label: 'Unemployed', value: 'unemployed' },
        { label: 'Self-employed', value: 'self-employed' },
        { label: 'Student', value: 'student' },
      ],
    },
    {
      name: 'unemployment_duration',
      type: 'select',
      label: form.i_am_applicant ? 'For approximately how long have you been unemployed?' : 'For approximately how long has the minor been unemployed?',
      options: [
        { label: 'Less than 3 months', value: 'less than 3 months' },
        { label: '3 to 6 months', value: '3 to 6 months' },
        { label: '6 months to 12 months', value: '6 months to 12 months' },
        { label: '12 months to 18 months', value: '12 months to 18 months' },
        { label: '18 months to 24 months', value: '18 months to 24 months' },
        { label: 'More than 24 months', value: 'more than 24 months' },
      ],
      hide: form.employment_status !== 'unemployed',
    },
    {
      name: 'current_employer',
      label: form.i_am_applicant ? 'Current employer' : 'Minor\'s current employer',
      hide: !['employed full time', 'employed part time', 'self-employed'].includes(form.employment_status),
      required: false,
    },
    {
      name: 'current_job_title',
      label: form.i_am_applicant ? 'Current job title/role' : 'Minor\'s current job title/role',
      hide: !['employed full time', 'employed part time', 'self-employed'].includes(form.employment_status),
      required: false,
    },
    {
      name: 'sector_of_employment',
      label: form.i_am_applicant ? 'What is your current sector of employment?' : 'What is the minor\'s current sector of employment?',
      type: 'select',
      options: [
        { label: 'Restaurants, Food & Beverage', value: 'restaurants food & beverage' },
        { label: 'Hotel Management & Administration', value: 'hotel management & administration' },
        { label: 'Other Tourism & Hospitality Work', value: 'other tourism & hospitality work' },
        { label: 'Financial Services', value: 'financial services' },
        { label: 'Health Care & Social Services', value: 'health care & social services' },
        { label: 'Education & Training', value: 'education & training' },
        { label: 'Technology & Startups', value: 'technology & startups' },
        { label: 'Transportation', value: 'transportation' },
        { label: 'Fishing & Agriculture', value: 'fishing & agriculture' },
        { label: 'Construction & Civil Engineering', value: 'construction & civil engineering' },
        { label: 'Manufacturing & Processing', value: 'manufacturing & processing' },
        { label: 'Government / Public Administration', value: 'government / public administration' },
        { label: 'Arts, Culture, Sport & Personal Services', value: 'arts, culture, sport & personal services' },
        { label: 'Retail Shops and Wholesale Trade', value: 'retail shops and wholesale trade' },
        { label: 'Real Estate / Property', value: 'real estate / property' },
        { label: 'Non-Financial Professional Services (such as Law)', value: 'non-financial professional services (such as law)' },
        { label: 'Other', value: 'other' },
      ],
      hide: !['employed full time', 'employed part time', 'self-employed'].includes(form.employment_status),
      hint: 'Please select the sector that most closely aligns with your field of work',
    },
    {
        name: 'other_sector_of_employment',
        label: form.i_am_applicant ? 'Please state your sector of employment' : 'Please state the minor\'s sector of employment',
        hide: form.sector_of_employment !='other'
    },
    {
      name: 'average_monthly_income',
      label: form.i_am_applicant ? 'Approximately how much is your average monthly income (BSD)?' : 'Approximately how much is the minor\'s average monthly income (BSD)?',
      type: 'currency',
      icon: 'text-$',
      min: 0,
      required: false,
      hint: `This information is confidential. The answer does not impact their eligibility and training is always free. 
        We ask this to measure how upskilling increases participant income over time. Enter 0 if the minor did not earn anything. 
        If the minor's income has fluctuated, please give the average monthly income.`,
      view: {
        value: value => {
          if (value === null || value === undefined) return 'N/A'
          return `$${parseFloat(value).toFixed(2)}`
        }
      },
      onBlur: value => {
        if (value < 0) {
          toastr.error('Average monthly income cannot be negative.')
          return { average_monthly_income: 0 }
        }
        const roundedValue = Math.round(value * 100) / 100
        if (roundedValue !== value) {
          toastr.info(`Average monthly income has been rounded to ${roundedValue.toFixed(2)}.`)
          return { average_monthly_income: roundedValue }
        }
      },
    },
    {
      name: 'internet_access',
      label: form.i_am_applicant ? 'What type of internet do you have access to for training?' : 'What type of internet does the minor have access to for training?',
      type: 'select',
      options: [
        { label: 'Mobile Phone Data', value: 'mobile phone data' },
        { label: 'Home Internet / WiFi', value: 'home internet / wifi' },
        { label: 'Public Wi-Fi', value: 'public wi-fi' },
        { label: 'No Internet Access', value: 'no internet access' },
      ],
    },
    {
      name: 'devices_for_training',
      label: form.i_am_applicant ? 'What device(s) do you have access to for training?' : 'What device(s) does the minor have access to for training?',
      type: 'select',
      options: [
        { label: 'Mobile Phone', value: 'mobile phone' },
        { label: 'Tablet', value: 'tablet' },
        { label: 'Laptop or Desktop Computer', value: 'laptop or desktop computer' },
        { label: 'Shared Computer', value: 'shared computer' },
        { label: 'I do not have access to a device at the moment', value: 'no device access' },
      ],
      multi: true,
      view: {
        value: value => {
          if (!value || value.length === 0) return 'N/A'
          return value.join(', ').capitalize()
        }
      }
    },
    {
      name: 'educational_background',
      label: form.i_am_applicant ? 'Education Background: Please select all the levels of education you have done in your life' : 'Education Background: Please select all the levels of education the minor has done in their life',
      type: 'select',
      options: [
        { label: 'Primary School', value: 'primary school' },
        { label: 'Junior High School', value: 'junior high school' },
        { label: 'Senior High School', value: 'senior high school' },
        { label: 'College / University', value: 'college / university' },
        { label: 'Vocational / Technical Training', value: 'vocational / technical training' },
        { label: 'Bachelor\'s Degree', value: 'bachelor\'s degree' },
        { label: 'Master\'s Degree', value: 'master\'s degree' },
        { label: 'Doctorate / PhD', value: 'doctorate / phd' },
      ],
      multi: true,
      view: {
        value: value => {
          if (!value || value.length === 0) return 'N/A'
          return value.join(', ').capitalize()
        }
      }
    },
    {
      name: 'accept_completion_commitment',
      type: 'checkbox',
      label: form.i_am_applicant ? 'I have checked the course duration and time commitment, and I am willing and able to complete it.' : 'The minor is aware of the course duration and time commitment, and is willing and able to complete it.',
      hide: true,
      save: true,
    },
    {
      name: 'accept_data_consent',
      type: 'checkbox',
      label: form.i_am_applicant ? `I understand I own my data at all times. I consent to the use of data for limited essential purposes, 
        such as to confirm eligibility, process my application, and to track outcomes.` : `I consent to the use of the minor's data for 
        limited essential purposes, such as to confirm eligibility, process the application, and to track outcomes.`,
      required: true,
    },
    {
      name: 'accept_start_date_commitment',
      type: 'checkbox',
      label: form.i_am_applicant ? `I commit to starting my selected course within two (2) weeks of being accepted into the programme and having access to the course.` : `The minor commits to starting their course within two (2) weeks of being accepted into the programme and having access to the course.`,
      hide: true,
      save: true,
    }
  ]

  render = () => (
    <Fragment>
      <Loader loading={this.state.loading} />
      <Wizard {...SERVICE_PROPS(this)} />
    </Fragment>
  )
}
